export default __webpack_public_path__ + "static/media/cairoMap.18c4a350.png";